import CooldownPeriod from "./CooldownPeriod";

export default CooldownPeriod;
